import { IHttpResponse } from "./types/http.types";
import { INetworkError } from "./types/http.types";
import { HTTP_ERROR_MESSAGE } from "../ServiceUtil/consts";
import { HttpCodes } from "../ServiceUtil/consts";

export interface IHttpHeaderDelegate
{
    handleHttpHeader(headerName: string, header: any);
}

/**
 * HttpDelegate provides static methods for handling HTTP responses and headers from the API
 */
export class HttpDelegate
{
    public static getHTTPError(response: IHttpResponse): INetworkError
    {
        const statusCode = response && response.status ? response.status : HttpCodes.NETWORK_TIMEOUT;

        return {
            message: statusCode === 401 ?  response.data : HTTP_ERROR_MESSAGE,
            code: statusCode,
            url: response.config.url,
            detailedMessage: HTTP_ERROR_MESSAGE + ` status = ${statusCode}`,
            modules: null,
            data: response.data
        };
    }

    /**
     * Check the HTTP response code and throw an exception if it was not a HTTP success code
     * @param response
     */
    public static checkHTTPResponse(response: IHttpResponse)
    {
        if (!response || response.status !== HttpCodes.OK)
        {
            throw HttpDelegate.getHTTPError(response);
        }
    }

    /**
     * Check the http headers from an HTTP response and handle appropriately
     * @param response is the HTTP response
     * @param httpHeaderDelegate is used to process any http headers that may be received
     */
    public static checkHTTPHeaders(response: IHttpResponse, httpHeaderDelegate: IHttpHeaderDelegate)
    {
        if (response.headers)
        {
            Object.keys(response.headers)
                .forEach((key) =>
                {
                    httpHeaderDelegate.handleHttpHeader(key, response.headers[key]);
                });
        }
    }
}